import { UtilsProvider } from './../../providers/utils/utils';
import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  Platform,
  ModalController, 
  LoadingController,
} from 'ionic-angular';
import { CameraOptions, Camera } from '@ionic-native/camera';
import { TasksProvider } from '../../providers/tasks/tasks';
import { FileContents, TaskData, TaskQL } from '../../providers/tasks/models';
import { ENV } from '../../environments/environment';
@IonicPage()
@Component({
  selector: 'page-task-invoice',
  templateUrl: 'task-invoice.html'
})
export class TaskInvoicePage {
  private task: any;
  private taskData: TaskData;
  private customer: any;
  private invoice: FileContents = null;
  private invoiceName: FileContents = null;
  private ready: boolean = false;
  private labels: any[];
  private errorMessage: string = undefined;
  loader: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private camera: Camera,
    private tasksProvider: TasksProvider,
    private platform: Platform,
    private modalCtrl: ModalController,
    private utilsProvider: UtilsProvider,
    public loadingCtrl: LoadingController,
  ) {}

  ngOnInit() {
    this.task = this.tasksProvider.getSelectedTask();
  }

  ionViewDidLoad() {
    this.readyCheck();
  }
  ionViewDidEnter() {
    this.taskData = this.tasksProvider.getTaskData(this.task.id);

    this.readyCheck();
  }

  readyCheck() {
    let flag = true;
    this.ready = flag;
  }

  removeInvoice(index) {
    this.invoice= null;
    this.readyCheck();
  }


  addInvoice(index, source = 1) {
    this.invoiceName = undefined;
    this.invoice = undefined;
  }

  addInvoiceInput(event) {
    const reader = new FileReader();

    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.invoiceName = file.name;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.invoice = {
          contentType: reader.result.toString().split(',')[0],
          content: reader.result.toString().split(',')[1]
        }
        this.invoice = {
          contentType: reader.result.toString().split(',')[0],
          content: reader.result.toString().split(',')[1]
        }
        this.readyCheck();
      };
    }
  }

  isCordova() {
    return this.platform.is('cordova');
  }

  chunk(arr, size) {
    var newArr = [];
    for (var i = 0; i < arr.length; i += size) {
      newArr.push(arr.slice(i, i + size));
    }
    return newArr;
  }
  cleanArray(actual) {
    var newArray = new Array();
    for (var i = 0; i < actual.length; i++) {
      if ((actual[i] && actual[i].data) || i < 5) {
        newArray.push(actual[i]);
      }
    }
    return newArray;
  }

  cancel() {
    this.navCtrl.pop();
  }
  
  upload() {

    this.presentLoading('Uploading');
    this.errorMessage = undefined;
    //uploadInvoice(invoice, name, obs = null, taskid)
    this.utilsProvider.uploadInvoice(this.invoice, this.invoiceName, null, this.task.id).subscribe(
      response => {
        this.loader.dismiss();
        this.navCtrl.pop();
      },
      error => {
        console.log('error!',error);
        this.errorMessage = "Upload failed: " + error.message;
        this.loader.dismiss();
      },
    );
  }


  presentLoading(content: string = '') {
    this.loader = this.loadingCtrl.create({
      content
    });
    this.loader.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/task-invoice/task-invoice.ts